"use client";

import { c as _c } from "react/compiler-runtime";
import { AuthContext } from "@/components/auth/Auth";
import { ReactQueryWrapperContext } from "@/components/react-query-wrapper/ReactQueryWrapper";
import { ApiCreateOrUpdateProfileCicStatement, CicStatement } from "@/entities/IProfile";
import { ApiIdentity } from "@/generated/models/ApiIdentity";
import { STATEMENT_GROUP, STATEMENT_META, STATEMENT_TYPE } from "@/helpers/Types";
import { commonApiPost } from "@/services/api/common-api";
import { useMutation } from "@tanstack/react-query";
import { useContext, useEffect, useState } from "react";
import UserPageIdentityAddStatementsInput from "./UserPageIdentityAddStatementsInput";
export default function UserPageIdentityAddStatementsForm(t0) {
  const $ = _c(46);
  const {
    profile,
    activeType,
    group,
    onClose
  } = t0;
  const {
    requestAuth,
    setToast
  } = useContext(AuthContext);
  const {
    onProfileStatementAdd
  } = useContext(ReactQueryWrapperContext);
  const [value, setValue] = useState(STATEMENT_META[activeType].inputInitialValue);
  let t1;
  let t2;
  if ($[0] !== activeType) {
    t1 = () => {
      setValue(STATEMENT_META[activeType].inputInitialValue);
    };
    t2 = [activeType];
    $[0] = activeType;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  const [loading, setLoading] = useState(false);
  let t3;
  if ($[3] !== activeType || $[4] !== group || $[5] !== profile) {
    t3 = async statement => {
      setLoading(true);
      return await commonApiPost({
        endpoint: `profiles/${profile.query}/cic/statements`,
        body: {
          statement_group: group,
          statement_type: activeType,
          statement_comment: null,
          statement_value: statement
        }
      });
    };
    $[3] = activeType;
    $[4] = group;
    $[5] = profile;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== onProfileStatementAdd || $[8] !== profile || $[9] !== setToast) {
    t4 = () => {
      setToast({
        message: "NIC statement added.",
        type: "success"
      });
      onProfileStatementAdd({
        profile
      });
    };
    $[7] = onProfileStatementAdd;
    $[8] = profile;
    $[9] = setToast;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== setToast) {
    t5 = error => {
      setToast({
        message: error as unknown as string,
        type: "error"
      });
    };
    $[11] = setToast;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = () => {
      setLoading(false);
    };
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t3 || $[15] !== t4 || $[16] !== t5) {
    t7 = {
      mutationFn: t3,
      onSuccess: t4,
      onError: t5,
      onSettled: t6
    };
    $[14] = t3;
    $[15] = t4;
    $[16] = t5;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  const addStatementMutation = useMutation(t7);
  let t8;
  if ($[18] !== addStatementMutation || $[19] !== onClose || $[20] !== requestAuth || $[21] !== value) {
    t8 = async event => {
      event.preventDefault();
      if (!value) {
        return;
      }
      const {
        success
      } = await requestAuth();
      if (!success) {
        return;
      }
      await addStatementMutation.mutateAsync(value);
      setValue("");
      onClose();
    };
    $[18] = addStatementMutation;
    $[19] = onClose;
    $[20] = requestAuth;
    $[21] = value;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  const onSubmit = t8;
  let t9;
  if ($[23] !== activeType || $[24] !== value) {
    t9 = <UserPageIdentityAddStatementsInput activeType={activeType} value={value} onChange={setValue} />;
    $[23] = activeType;
    $[24] = value;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  const t10 = `
              tw-w-full sm:tw-w-auto  tw-flex tw-items-center tw-justify-center tw-relative tw-px-4 tw-py-3 tw-text-sm tw-font-semibold tw-text-white tw-border tw-border-solid tw-rounded-lg tw-transition tw-duration-300 tw-ease-out ${loading ? "tw-cursor-not-allowed tw-bg-iron-400 tw-border-iron-400" : "tw-cursor-pointer tw-bg-primary-500 tw-border-primary-500 hover:tw-bg-primary-600 hover:tw-border-primary-600"}`;
  const t11 = loading ? "hidden" : "visible";
  let t12;
  if ($[26] !== t11) {
    t12 = <div style={{
      visibility: t11
    }}>Save</div>;
    $[26] = t11;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  let t13;
  if ($[28] !== loading) {
    t13 = loading && <svg aria-hidden="true" role="output" className="tw-inline tw-w-5 tw-h-5 tw-text-primary-400 tw-animate-spin tw-absolute" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg"><path className="tw-text-iron-600" d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" /><path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentColor" /></svg>;
    $[28] = loading;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  let t14;
  if ($[30] !== loading || $[31] !== t10 || $[32] !== t12 || $[33] !== t13) {
    t14 = <button disabled={loading} type="submit" className={t10}>{t12}{t13}</button>;
    $[30] = loading;
    $[31] = t10;
    $[32] = t12;
    $[33] = t13;
    $[34] = t14;
  } else {
    t14 = $[34];
  }
  const t15 = `tw-mt-3 sm:tw-mt-0 tw-w-full sm:tw-w-auto tw-bg-iron-900 tw-px-4 tw-py-3 tw-text-sm tw-font-semibold tw-text-white tw-border tw-border-solid tw-border-iron-700 tw-rounded-lg  tw-transition tw-duration-300 tw-ease-out  ${loading ? "tw-cursor-not-allowed" : "hover:tw-bg-iron-800 hover:tw-border-iron-700"}`;
  let t16;
  if ($[35] !== loading || $[36] !== onClose || $[37] !== t15) {
    t16 = <button disabled={loading} onClick={onClose} type="button" className={t15}>Cancel</button>;
    $[35] = loading;
    $[36] = onClose;
    $[37] = t15;
    $[38] = t16;
  } else {
    t16 = $[38];
  }
  let t17;
  if ($[39] !== t14 || $[40] !== t16) {
    t17 = <div className="tw-mt-8"><div className="sm:tw-flex sm:tw-flex-row-reverse tw-gap-x-3">{t14}{t16}</div></div>;
    $[39] = t14;
    $[40] = t16;
    $[41] = t17;
  } else {
    t17 = $[41];
  }
  let t18;
  if ($[42] !== onSubmit || $[43] !== t17 || $[44] !== t9) {
    t18 = <div className="tw-mt-4"><form onSubmit={onSubmit}>{t9}{t17}</form></div>;
    $[42] = onSubmit;
    $[43] = t17;
    $[44] = t9;
    $[45] = t18;
  } else {
    t18 = $[45];
  }
  return t18;
}